import { authService } from './service'
import { createFetchHook } from '../../acato-utils'

export const authServiceHooks = createFetchHook(authService)
